import { slicedToArray as _slicedToArray, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { filterDOMProps } from '@react-aria/utils';
import React, { useContext } from 'react';
import { useListBoxSection } from 'react-aria';
import { ListStateContext } from 'react-aria-components';
import Option from './option.esm.js';
import SectionHeader from './section-header.esm.js';
import { useSlot } from '../../../utils/index.esm.js';
import { useCachedChildren } from '../collection.esm.js';

function ListBoxSection(_ref) {
  var _section$props$ariaL, _section$props, _section$props2;
  var section = _ref.section,
    className = _ref.className,
    style = _ref.style;
  var state = useContext(ListStateContext);
  var _useSlot = useSlot(),
    _useSlot2 = _slicedToArray(_useSlot, 2),
    headingRef = _useSlot2[0],
    heading = _useSlot2[1];
  var _useListBoxSection = useListBoxSection({
      heading: heading,
      'aria-label': (_section$props$ariaL = section.props['aria-label']) !== null && _section$props$ariaL !== void 0 ? _section$props$ariaL : undefined
    }),
    headingProps = _useListBoxSection.headingProps,
    groupProps = _useListBoxSection.groupProps;
  var children = useCachedChildren({
    items: state.collection.getChildren(section.key),
    children: function children(item) {
      switch (item.type) {
        case 'header':
          {
            return /*#__PURE__*/React.createElement(SectionHeader, {
              item: item,
              headingProps: headingProps,
              headingRef: headingRef
            });
          }
        case 'item':
          return /*#__PURE__*/React.createElement(Option, {
            item: item
          });
        default:
          throw new Error('Unsupported element type in Section: ' + item.type);
      }
    }
  });
  return /*#__PURE__*/React.createElement("section", _extends({}, filterDOMProps(section.props), groupProps, {
    className: className || ((_section$props = section.props) === null || _section$props === void 0 ? void 0 : _section$props.className) || 'react-aria-Section',
    style: style || ((_section$props2 = section.props) === null || _section$props2 === void 0 ? void 0 : _section$props2.style),
    ref: section.props.ref
  }), children);
}

export { ListBoxSection as default };
//# sourceMappingURL=list-box-section.esm.js.map
